import { TrackedChange } from 'components/TrackedChange/TrackedChange'
import { useTrackedChange } from 'hooks/queries/trackedChanges/useTrackedChange'
import { isEqual } from 'lodash'
import { observer } from 'mobx-react-lite'
import { memo } from 'react'
import { useDocStore } from 'stores/DocStore'
import { DefinitelyTrackedChangeProps, MaybeTrackedChangeProps } from './Types'

const DefinitelyTrackedChange = ({
  trackedChange,
  articleId,
  layerId,
  inCleanupMode = false,
}: DefinitelyTrackedChangeProps) => {
  const trackedChangeRecord = useTrackedChange({ articleKey: articleId, layerId, id: trackedChange.uuid })
  const comments = trackedChangeRecord?.comments || []

  return <TrackedChange items={[trackedChange, ...comments]} inCleanupMode={inCleanupMode} />
}

const MaybeTrackedChange = observer(({ trackedChange, inCleanupMode }: MaybeTrackedChangeProps) => {
  const docStore = useDocStore()
  if (!docStore.layerId) {
    return <TrackedChange items={[trackedChange]} inCleanupMode={inCleanupMode} />
  }

  return (
    <DefinitelyTrackedChange
      trackedChange={trackedChange}
      articleId={docStore.articleId}
      layerId={docStore.layerId}
      inCleanupMode={inCleanupMode}
    />
  )
})

const areEqual = (prevProps: MaybeTrackedChangeProps, nextProps: MaybeTrackedChangeProps) => {
  const {
    trackedChange: { nodes: prevNodes, ...prevChange },
    ...prev
  } = prevProps
  const {
    trackedChange: { nodes: nextNodes, ...nextChange },
    ...next
  } = nextProps
  const prevNodesJSON = prevNodes.map((node) => node.toJSON())
  const nextNodesJSON = nextNodes.map((node) => node.toJSON())

  return isEqual(prev, next) && isEqual(prevChange, nextChange) && isEqual(prevNodesJSON, nextNodesJSON)
}

const memoized = memo(MaybeTrackedChange, areEqual)

export { memoized as MaybeTrackedChange }
